import { getCurrentPath, navigate } from './backboneBridge';

export const NavigationService = {
    _lastPath: null,      // The literal last page (e.g., Show)
    _rootContext: 'home', // The exit point (e.g., List or Tree)

    navigateTo(href, options = { trigger: true }) {
        const current = getCurrentPath();

        if (href.includes('/show') && !current.includes('/edit')) {
            this._rootContext = current || 'home';
        }

        if (href !== current) {
            this._lastPath = current;
        }

        navigate(href, options);
    },

    getCancelHref() {
        return this._lastPath || 'home';
    },

    getBackHref() {
        return this._rootContext || 'home';
    }
};
